@if (badgeInfo?.count && showBubble()) {
    <span class="relative">
        <je-fa-icon [name]="item.icon" [size]="'large'"></je-fa-icon>
        <span class="absolute -top-4 -right-8 min-w-[16px] h-4 p-2 bg-blue-800 text-white text-xs font-bold rounded-full flex items-center justify-start shadow">
            {{ badgeInfo.count }}
        </span>
    </span>
} @else {
    <je-fa-icon [name]="item.icon" [size]="'large'"></je-fa-icon>
}
